import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ErrorToken, createCustomErrorContext } from 'src/app/core/interceptors/generic-error-handling-interceptors';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SendSmsService {

  constructor(private http: HttpClient) { }

  sendSms(recipient: string, message: string, errorToken?: ErrorToken[]): Observable<any> {
    return this.http.post(`${environment.apiEndpoint}/api/v1/sms/send`,
    { recipient: recipient, message: message },
    errorToken ? { context: createCustomErrorContext(errorToken) } : undefined
    );
  }

}
